import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "Requests";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const RequestsActions = { ...slice.actions, ...extraActions };
export const RequestsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        InmateRequestFormPermissionDetails: [],
        InmateRequestFormSearchDetails: [],
        InmateMGUserRequestFormSearchDetails: [],
        LoadFacilityRequestFormPermissionDetails: [],
        ValidateInmateCreateRequestFormDetails: [],
        RequestAdminRemedyCUDResponse: [],
        RequestPublicDefenderThreadInsertResponse: [],
        RequestForumThreadInsertResponse: [],
        InmateRequestAdminRemedyResponse: [],
        InmateRequestPublicDefenderThreadResponse: [],
        InmateRequestPublicDefenderThreadPostResponse: [],
        loadInmateRequestForumThreadResponse: [],
        InmateRequestForumThreadPostResponse: [],
        InmateRequestVisitorInfoResponse: [],
        GetAllStatesDetails: [],
        CreateUpdateRequestInmateVisitorResponse: [],
        IRRequestFormCUDResponse: [],
        InmateRequestIRRequestFormResponse: [],
        GetInmateRequestPublicDefenderResponse: [],
        RequestPublicDefenderServicesCUDResponse: [],
        LoadRelationshipsResponse: [],
        loadUpdateInmateMGUserRequestReadResponse: [],
        LoadInmateMGUserRequestForumThreadResponse: [],
        LoadInmateMGUserRequestForumThreadPostResponse: [],
        LoadRequestForumMGUserThreadRespondResponse: [],
        LoadRequestForumThreadRespondResponse: [],
        UpdateInmateRequestReadResponse: [],
        LoadInmateMGUserRequestUnReadCountResponse: [],
        RequestPublicDefenderThreadRespondResponse: [],
        GetInmateDetailsPDRequestResponse: [],
        InmateRequestPdsNotesDetailsResponse: []
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getInmateRequestFormPermission: getInmateRequestFormPermission(),
        getInmateRequestFormSearch: getInmateRequestFormSearch(),
        getInmateMGUserRequestFormSearch: getInmateMGUserRequestFormSearch(),
        getLoadFacilityRequestFormPermission: getLoadFacilityRequestFormPermission(),
        getValidateInmateCreateRequestForm: getValidateInmateCreateRequestForm(),
        loadRequestAdminRemedyCUD: loadRequestAdminRemedyCUD(),
        loadRequestPublicDefenderThreadInsert: loadRequestPublicDefenderThreadInsert(),
        loadRequestForumThreadInsert: loadRequestForumThreadInsert(),
        loadInmateRequestAdminRemedy: loadInmateRequestAdminRemedy(),
        loadInmateRequestPublicDefenderThread: loadInmateRequestPublicDefenderThread(),
        loadInmateRequestPublicDefenderThreadPost: loadInmateRequestPublicDefenderThreadPost(),
        loadInmateRequestForumThread: loadInmateRequestForumThread(),
        loadInmateRequestForumThreadPost: loadInmateRequestForumThreadPost(),
        loadInmateRequestVisitorInfo: loadInmateRequestVisitorInfo(),
        loadGetAllStates: loadGetAllStates(),
        loadCreateUpdateRequestInmateVisitor: loadCreateUpdateRequestInmateVisitor(),
        loadIRRequestFormCUD: loadIRRequestFormCUD(),
        loadInmateRequestIRRequestForm: loadInmateRequestIRRequestForm(),
        GetInmateRequestPublicDefender: GetInmateRequestPublicDefender(),
        loadRequestPublicDefenderServicesCUD: loadRequestPublicDefenderServicesCUD(),
        LoadRelationships: LoadRelationships(),
        LoadUpdateInmateMGUserRequestRead: LoadUpdateInmateMGUserRequestRead(),
        LoadInmateMGUserRequestForumThread: LoadInmateMGUserRequestForumThread(),
        LoadInmateMGUserRequestForumThreadPost: LoadInmateMGUserRequestForumThreadPost(),
        LoadRequestForumMGUserThreadRespond: LoadRequestForumMGUserThreadRespond(),
        LoadRequestForumThreadRespond: LoadRequestForumThreadRespond(),
        LoadUpdateInmateRequestRead: LoadUpdateInmateRequestRead(),
        LoadInmateMGUserRequestUnReadCount: LoadInmateMGUserRequestUnReadCount(),
        LoadRequestPublicDefenderThreadRespond: LoadRequestPublicDefenderThreadRespond(),
        LoadGetInmateDetailsPDRequest: LoadGetInmateDetailsPDRequest(),
        LoadInmateRequestPdsNotesDetails: LoadInmateRequestPdsNotesDetails(),
        loadSendEmailToDisciplinaryReportAppeals: loadSendEmailToDisciplinaryReportAppeals()
    };

    function loadSendEmailToDisciplinaryReportAppeals() {
        return createAsyncThunk(
            `${name}/loadSendEmailToDisciplinaryReportAppeals`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/SendEmailToDisciplinaryReportAppeals?emailTo=${objData?.emailTo}&inmateName=${objData?.inmateName}&inmateId=${objData?.inmateId}&appealSubmissionDateTime=${objData?.appealSubmissionDateTime}&facilityName=${objData?.facilityName} `)
        )
    }


    function LoadInmateRequestPdsNotesDetails() {
        return createAsyncThunk(
            `${name}/LoadInmateRequestPdsNotesDetails`,
            async (requestFormTypeId) =>
                await fetchWrapper.get(`${baseUrl}/Kiosk/PDS/GetInmateRequestPdsNotesDetails?pDSRequestFormTypeID=${requestFormTypeId}`)
        )
    }

    function LoadGetInmateDetailsPDRequest() {
        return createAsyncThunk(
            `${name}/LoadGetInmateDetailsPDRequest`,
            async ({ inmateId, requestFormTypeId }) =>
                await fetchWrapper.get(`${baseUrl}/Kiosk/PDS/GetInmateDetailsPDRequest?inmatesId=${inmateId}&requestFormTypeID=${requestFormTypeId}`)
        )
    }

    function LoadRequestPublicDefenderThreadRespond() {
        return createAsyncThunk(
            `${name}/LoadRequestPublicDefenderThreadRespond`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/RequestPublicDefenderThreadRespond`, objData)
        );
    }

    function LoadInmateMGUserRequestUnReadCount() {
        return createAsyncThunk(
            `${name}/LoadInmateMGUserRequestUnReadCount`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Common/LoadInmateMGUserRequestUnReadCount?inmateID=${objData?.inmatesId}&facilityID=${objData?.facilityID}`)
        )
    }

    function LoadUpdateInmateRequestRead() {
        return createAsyncThunk(
            `${name}/LoadUpdateInmateRequestRead`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/UpdateInmateRequestRead?inmatesId=${objData?.inmatesId}&facilityID=${objData?.facilityID}
                    &formReqAccess=${objData?.formReqAccess}&requestAdminRemedyID=${objData?.requestAdminRemedyID}`)
        )
    }

    function LoadRequestForumThreadRespond() {
        return createAsyncThunk(
            `${name}/LoadRequestForumThreadRespond`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/RequestForumThreadRespond`, objData)
        );
    }


    function LoadRequestForumMGUserThreadRespond() {
        return createAsyncThunk(
            `${name}/LoadRequestForumMGUserThreadRespond`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyQuery/RequestForumMGUserThreadRespond`, objData)
        );
    }


    function LoadInmateMGUserRequestForumThreadPost() {
        return createAsyncThunk(
            `${name}/LoadInmateMGUserRequestForumThreadPost`,
            async (requestForumThreadID) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyQuery/InmateMGUserRequestForumThreadPost?requestForumThreadID=${requestForumThreadID}&isInmate=${1}&isMGUser=${0}`)
        )
    }

    function LoadInmateMGUserRequestForumThread() {
        return createAsyncThunk(
            `${name}/LoadInmateMGUserRequestForumThread`,
            async (requestForumThreadID) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyQuery/InmateMGUserRequestForumThread?requestForumThreadID=${requestForumThreadID}&isInmate=${1}&isMGUser=${0}`)
        )
    }

    function LoadUpdateInmateMGUserRequestRead() {
        return createAsyncThunk(
            `${name}/LoadUpdateInmateMGUserRequestRead`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyQuery/UpdateInmateMGUserRequestRead`, objData)
        );
    }

    function LoadRelationships() {
        return createAsyncThunk(
            `${name}/LoadRelationships`,
            async () =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/LoadRelationships`)
        );
    }

    function loadRequestPublicDefenderServicesCUD() {
        return createAsyncThunk(
            `${name}/loadRequestPublicDefenderServicesCUD`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/PDS/RequestPublicDefenderServicesCUD`, objData)
        );
    }

    function GetInmateRequestPublicDefender() {
        return createAsyncThunk(
            `${name}/GetInmateRequestPublicDefender`,
            async (noticesId) =>
                await fetchWrapper.get(`${baseUrl}/Kiosk/PDS/GetInmateRequestPublicDefender?noticesId=${noticesId}`)
        );
    }

    function loadInmateRequestIRRequestForm() {
        return createAsyncThunk(
            `${name}/loadInmateRequestIRRequestForm`,
            async (noticesId) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestIRRequestForm?noticesId=${noticesId}`)
        );
    }
    function loadIRRequestFormCUD() {
        return createAsyncThunk(
            `${name}/loadIRRequestFormCUD`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/IRRequestFormCUD`, objData)
        );
    }
    function loadCreateUpdateRequestInmateVisitor() {
        return createAsyncThunk(
            `${name}/loadCreateUpdateRequestInmateVisitor`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/CreateUpdateRequestInmateVisitor`, objData)
        );
    }
    function loadGetAllStates() {
        return createAsyncThunk(
            `${name}/loadGetAllStates`,
            async () =>
                await fetchWrapper.get(`${baseUrl}/Common/GetAllStates`)
        );
    }
    function getInmateRequestFormPermission() {
        return createAsyncThunk(
            `${name}/getInmateRequestFormPermission`,
            async (loginResponse) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestFormPermission?inmateId=${loginResponse?.InmateID}&facilityId=${loginResponse?.facilityID}`)
        );
    }
    function getInmateRequestFormSearch() {
        return createAsyncThunk(
            `${name}/getInmateRequestFormSearch`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestFormSearch`, objData)
        );
    }
    function getInmateMGUserRequestFormSearch() {
        return createAsyncThunk(
            `${name}/getInmateMGUserRequestFormSearch`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/MyQuery/InmateMGUserRequestFormSearch`, objData)
        );
    }
    function getLoadFacilityRequestFormPermission() {
        return createAsyncThunk(
            `${name}/getLoadFacilityRequestFormPermission`,
            async (loginResponse) =>
                await fetchWrapper.get(`${baseUrl}/Kiosk/Requests/GetFacilityRequestFormPermissionList?facilityID=${loginResponse?.facilityID}`)
        );
    }
    function getValidateInmateCreateRequestForm() {
        return createAsyncThunk(
            `${name}/getValidateInmateCreateRequestForm`,
            async ({ inmateId, facilityId, requestFormTypeId }) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/ValidateInmateCreateRequestForm?inmateId=${inmateId}&facilityId=${facilityId}&requestFormTypeId=${requestFormTypeId}`)
        );
    }
    function loadRequestAdminRemedyCUD() {
        return createAsyncThunk(
            `${name}/loadRequestAdminRemedyCUD`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/RequestAdminRemedyCUD`, objData)
        );
    }
    function loadRequestPublicDefenderThreadInsert() {
        return createAsyncThunk(
            `${name}/loadRequestPublicDefenderThreadInsert`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/RequestPublicDefenderThreadInsert`, objData)
        );
    }
    function loadRequestForumThreadInsert() {
        return createAsyncThunk(
            `${name}/loadRequestForumThreadInsert`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/RequestForumThreadInsert`, objData)
        );
    }
    function loadInmateRequestAdminRemedy() {
        return createAsyncThunk(
            `${name}/loadInmateRequestAdminRemedy`,
            async (requestAdminRemedyID) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestAdminRemedy?requestAdminRemedyID=${requestAdminRemedyID}`)
        );
    }
    function loadInmateRequestPublicDefenderThread() {
        return createAsyncThunk(
            `${name}/loadInmateRequestPublicDefenderThread`,
            async (noticesId) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestPublicDefenderThread?noticesId=${noticesId}`)
        );
    }
    function loadInmateRequestPublicDefenderThreadPost() {
        return createAsyncThunk(
            `${name}/loadInmateRequestPublicDefenderThreadPost`,
            async (noticesId) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestPublicDefenderThreadPost?noticesId=${noticesId}&isInmate=${1}`)
        );
    }
    function loadInmateRequestForumThread() {
        return createAsyncThunk(
            `${name}/loadInmateRequestForumThread`,
            async ({ formReqAccess, storedloginResponse }) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestForumThread?formReqAccess=${formReqAccess}&facilityID=${storedloginResponse?.facilityID}&inmatesId=${storedloginResponse?.InmateID}`)
        );
    }
    function loadInmateRequestForumThreadPost() {
        return createAsyncThunk(
            `${name}/loadInmateRequestForumThreadPost`,
            async (formReqAccess) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestForumThreadPost?formReqAccess=${formReqAccess}&isInmate=${1}`)
        );
    }
    function loadInmateRequestVisitorInfo() {
        return createAsyncThunk(
            `${name}/loadInmateRequestVisitorInfo`,
            async (noticesId) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/Requests/InmateRequestVisitorInfo?noticesId=${noticesId}`)
        );
    }
}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.LoadInmateRequestPdsNotesDetails.pending, (state) => {
            state.InmateRequestPdsNotesDetailsResponse = [];
        })
        .addCase(actions.LoadInmateRequestPdsNotesDetails.fulfilled, (state, action) => {
            state.InmateRequestPdsNotesDetailsResponse = action.payload;
        })
        .addCase(actions.LoadInmateRequestPdsNotesDetails.rejected, (state, action) => {
            state.InmateRequestPdsNotesDetailsResponse = { error: action.error };
        })
        .addCase(actions.LoadGetInmateDetailsPDRequest.pending, (state) => {
            state.GetInmateDetailsPDRequestResponse = [];
        })
        .addCase(actions.LoadGetInmateDetailsPDRequest.fulfilled, (state, action) => {
            state.GetInmateDetailsPDRequestResponse = action.payload;
        })
        .addCase(actions.LoadGetInmateDetailsPDRequest.rejected, (state, action) => {
            state.GetInmateDetailsPDRequestResponse = { error: action.error };
        })
        .addCase(actions.LoadRequestPublicDefenderThreadRespond.pending, (state) => {
            state.RequestPublicDefenderThreadRespondResponse = [];
        })
        .addCase(actions.LoadRequestPublicDefenderThreadRespond.fulfilled, (state, action) => {
            state.RequestPublicDefenderThreadRespondResponse = action.payload;
        })
        .addCase(actions.LoadRequestPublicDefenderThreadRespond.rejected, (state, action) => {
            state.RequestPublicDefenderThreadRespondResponse = { error: action.error };
        })
        .addCase(actions.LoadInmateMGUserRequestUnReadCount.pending, (state) => {
            state.LoadInmateMGUserRequestUnReadCountResponse = [];
        })
        .addCase(actions.LoadInmateMGUserRequestUnReadCount.fulfilled, (state, action) => {
            state.LoadInmateMGUserRequestUnReadCountResponse = action.payload;
        })
        .addCase(actions.LoadInmateMGUserRequestUnReadCount.rejected, (state, action) => {
            state.LoadInmateMGUserRequestUnReadCountResponse = { error: action.error };
        })
        .addCase(actions.LoadUpdateInmateRequestRead.pending, (state) => {
            state.UpdateInmateRequestReadResponse = [];
        })
        .addCase(actions.LoadUpdateInmateRequestRead.fulfilled, (state, action) => {
            state.UpdateInmateRequestReadResponse = action.payload;
        })
        .addCase(actions.LoadUpdateInmateRequestRead.rejected, (state, action) => {
            state.UpdateInmateRequestReadResponse = { error: action.error };
        })
        .addCase(actions.LoadRequestForumThreadRespond.pending, (state) => {
            state.LoadRequestForumThreadRespondResponse = [];
        })
        .addCase(actions.LoadRequestForumThreadRespond.fulfilled, (state, action) => {
            state.LoadRequestForumThreadRespondResponse = action.payload;
        })
        .addCase(actions.LoadRequestForumThreadRespond.rejected, (state, action) => {
            state.LoadRequestForumThreadRespondResponse = { error: action.error };
        })
        .addCase(actions.getInmateRequestFormPermission.pending, (state) => {
            state.InmateRequestFormPermissionDetails = [];
        })
        .addCase(actions.getInmateRequestFormPermission.fulfilled, (state, action) => {
            state.InmateRequestFormPermissionDetails = action.payload;
        })
        .addCase(actions.getInmateRequestFormPermission.rejected, (state, action) => {
            state.InmateRequestFormPermissionDetails = { error: action.error };
        })
        .addCase(actions.getInmateRequestFormSearch.pending, (state) => {
            state.InmateRequestFormSearchDetails = [];
        })
        .addCase(actions.getInmateRequestFormSearch.fulfilled, (state, action) => {
            state.InmateRequestFormSearchDetails = action.payload;
        })
        .addCase(actions.getInmateRequestFormSearch.rejected, (state, action) => {
            state.InmateRequestFormSearchDetails = { error: action.error };
        })
        .addCase(actions.getInmateMGUserRequestFormSearch.pending, (state) => {
            state.InmateMGUserRequestFormSearchDetails = [];
        })
        .addCase(actions.getInmateMGUserRequestFormSearch.fulfilled, (state, action) => {
            state.InmateMGUserRequestFormSearchDetails = action.payload;
        })
        .addCase(actions.getInmateMGUserRequestFormSearch.rejected, (state, action) => {
            state.InmateMGUserRequestFormSearchDetails = { error: action.error };
        })
        .addCase(actions.getLoadFacilityRequestFormPermission.pending, (state) => {
            state.LoadFacilityRequestFormPermissionDetails = [];
        })
        .addCase(actions.getLoadFacilityRequestFormPermission.fulfilled, (state, action) => {
            state.LoadFacilityRequestFormPermissionDetails = action.payload;
        })
        .addCase(actions.getLoadFacilityRequestFormPermission.rejected, (state, action) => {
            state.LoadFacilityRequestFormPermissionDetails = { error: action.error };
        })
        .addCase(actions.getValidateInmateCreateRequestForm.pending, (state) => {
            state.ValidateInmateCreateRequestFormDetails = [];
        })
        .addCase(actions.getValidateInmateCreateRequestForm.fulfilled, (state, action) => {
            state.ValidateInmateCreateRequestFormDetails = action.payload;
        })
        .addCase(actions.getValidateInmateCreateRequestForm.rejected, (state, action) => {
            state.ValidateInmateCreateRequestFormDetails = { error: action.error };
        })
        .addCase(actions.loadRequestAdminRemedyCUD.pending, (state) => {
            state.RequestAdminRemedyCUDResponse = [];
        })
        .addCase(actions.loadRequestAdminRemedyCUD.fulfilled, (state, action) => {
            state.RequestAdminRemedyCUDResponse = action.payload;
        })
        .addCase(actions.loadRequestAdminRemedyCUD.rejected, (state, action) => {
            state.RequestAdminRemedyCUDResponse = { error: action.error };
        })
        .addCase(actions.loadRequestPublicDefenderThreadInsert.pending, (state) => {
            state.RequestPublicDefenderThreadInsertResponse = [];
        })
        .addCase(actions.loadRequestPublicDefenderThreadInsert.fulfilled, (state, action) => {
            state.RequestPublicDefenderThreadInsertResponse = action.payload;
        })
        .addCase(actions.loadRequestPublicDefenderThreadInsert.rejected, (state, action) => {
            state.RequestPublicDefenderThreadInsertResponse = { error: action.error };
        })
        .addCase(actions.loadRequestForumThreadInsert.pending, (state) => {
            state.RequestForumThreadInsertResponse = [];
        })
        .addCase(actions.loadRequestForumThreadInsert.fulfilled, (state, action) => {
            state.RequestForumThreadInsertResponse = action.payload;
        })
        .addCase(actions.loadRequestForumThreadInsert.rejected, (state, action) => {
            state.RequestForumThreadInsertResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestAdminRemedy.pending, (state) => {
            state.InmateRequestAdminRemedyResponse = [];
        })
        .addCase(actions.loadInmateRequestAdminRemedy.fulfilled, (state, action) => {
            state.InmateRequestAdminRemedyResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestAdminRemedy.rejected, (state, action) => {
            state.InmateRequestAdminRemedyResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestPublicDefenderThread.pending, (state) => {
            state.InmateRequestPublicDefenderThreadResponse = [];
        })
        .addCase(actions.loadInmateRequestPublicDefenderThread.fulfilled, (state, action) => {
            state.InmateRequestPublicDefenderThreadResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestPublicDefenderThread.rejected, (state, action) => {
            state.InmateRequestPublicDefenderThreadResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestPublicDefenderThreadPost.pending, (state) => {
            state.InmateRequestPublicDefenderThreadPostResponse = [];
        })
        .addCase(actions.loadInmateRequestPublicDefenderThreadPost.fulfilled, (state, action) => {
            state.InmateRequestPublicDefenderThreadPostResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestPublicDefenderThreadPost.rejected, (state, action) => {
            state.InmateRequestPublicDefenderThreadPostResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestForumThread.pending, (state) => {
            state.loadInmateRequestForumThreadResponse = [];
        })
        .addCase(actions.loadInmateRequestForumThread.fulfilled, (state, action) => {
            state.loadInmateRequestForumThreadResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestForumThread.rejected, (state, action) => {
            state.loadInmateRequestForumThreadResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestForumThreadPost.pending, (state) => {
            state.InmateRequestForumThreadPostResponse = [];
        })
        .addCase(actions.loadInmateRequestForumThreadPost.fulfilled, (state, action) => {
            state.InmateRequestForumThreadPostResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestForumThreadPost.rejected, (state, action) => {
            state.InmateRequestForumThreadPostResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestVisitorInfo.pending, (state) => {
            state.InmateRequestVisitorInfoResponse = [];
        })
        .addCase(actions.loadInmateRequestVisitorInfo.fulfilled, (state, action) => {
            state.InmateRequestVisitorInfoResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestVisitorInfo.rejected, (state, action) => {
            state.InmateRequestVisitorInfoResponse = { error: action.error };
        })
        .addCase(actions.loadGetAllStates.pending, (state) => {
            state.GetAllStatesDetails = [];
        })
        .addCase(actions.loadGetAllStates.fulfilled, (state, action) => {
            state.GetAllStatesDetails = action.payload;
        })
        .addCase(actions.loadGetAllStates.rejected, (state, action) => {
            state.GetAllStatesDetails = { error: action.error };
        })
        .addCase(actions.loadCreateUpdateRequestInmateVisitor.pending, (state) => {
            state.CreateUpdateRequestInmateVisitorResponse = [];
        })
        .addCase(actions.loadCreateUpdateRequestInmateVisitor.fulfilled, (state, action) => {
            state.CreateUpdateRequestInmateVisitorResponse = action.payload;
        })
        .addCase(actions.loadCreateUpdateRequestInmateVisitor.rejected, (state, action) => {
            state.CreateUpdateRequestInmateVisitorResponse = { error: action.error };
        })
        .addCase(actions.loadIRRequestFormCUD.pending, (state) => {
            state.IRRequestFormCUDResponse = [];
        })
        .addCase(actions.loadIRRequestFormCUD.fulfilled, (state, action) => {
            state.IRRequestFormCUDResponse = action.payload;
        })
        .addCase(actions.loadIRRequestFormCUD.rejected, (state, action) => {
            state.IRRequestFormCUDResponse = { error: action.error };
        })
        .addCase(actions.loadInmateRequestIRRequestForm.pending, (state) => {
            state.InmateRequestIRRequestFormResponse = [];
        })
        .addCase(actions.loadInmateRequestIRRequestForm.fulfilled, (state, action) => {
            state.InmateRequestIRRequestFormResponse = action.payload;
        })
        .addCase(actions.loadInmateRequestIRRequestForm.rejected, (state, action) => {
            state.InmateRequestIRRequestFormResponse = { error: action.error };
        })
        .addCase(actions.GetInmateRequestPublicDefender.pending, (state) => {
            state.GetInmateRequestPublicDefenderResponse = [];
        })
        .addCase(actions.GetInmateRequestPublicDefender.fulfilled, (state, action) => {
            state.GetInmateRequestPublicDefenderResponse = action.payload;
        })
        .addCase(actions.GetInmateRequestPublicDefender.rejected, (state, action) => {
            state.GetInmateRequestPublicDefenderResponse = { error: action.error };
        })
        .addCase(actions.loadRequestPublicDefenderServicesCUD.pending, (state) => {
            state.RequestPublicDefenderServicesCUDResponse = [];
        })
        .addCase(actions.loadRequestPublicDefenderServicesCUD.fulfilled, (state, action) => {
            state.RequestPublicDefenderServicesCUDResponse = action.payload;
        })
        .addCase(actions.loadRequestPublicDefenderServicesCUD.rejected, (state, action) => {
            state.RequestPublicDefenderServicesCUDResponse = { error: action.error };
        })
        .addCase(actions.LoadRelationships.pending, (state) => {
            state.LoadRelationshipsResponse = [];
        })
        .addCase(actions.LoadRelationships.fulfilled, (state, action) => {
            state.LoadRelationshipsResponse = action.payload;
        })
        .addCase(actions.LoadRelationships.rejected, (state, action) => {
            state.LoadRelationshipsResponse = { error: action.error };
        })
        .addCase(actions.LoadUpdateInmateMGUserRequestRead.pending, (state) => {
            state.loadUpdateInmateMGUserRequestReadResponse = [];
        })
        .addCase(actions.LoadUpdateInmateMGUserRequestRead.fulfilled, (state, action) => {
            state.loadUpdateInmateMGUserRequestReadResponse = action.payload;
        })
        .addCase(actions.LoadUpdateInmateMGUserRequestRead.rejected, (state, action) => {
            state.loadUpdateInmateMGUserRequestReadResponse = { error: action.error };
        })
        .addCase(actions.LoadInmateMGUserRequestForumThread.pending, (state) => {
            state.LoadInmateMGUserRequestForumThreadResponse = [];
        })
        .addCase(actions.LoadInmateMGUserRequestForumThread.fulfilled, (state, action) => {
            state.LoadInmateMGUserRequestForumThreadResponse = action.payload;
        })
        .addCase(actions.LoadInmateMGUserRequestForumThread.rejected, (state, action) => {
            state.LoadInmateMGUserRequestForumThreadResponse = { error: action.error };
        })
        .addCase(actions.LoadInmateMGUserRequestForumThreadPost.pending, (state) => {
            state.LoadInmateMGUserRequestForumThreadPostResponse = [];
        })
        .addCase(actions.LoadInmateMGUserRequestForumThreadPost.fulfilled, (state, action) => {
            state.LoadInmateMGUserRequestForumThreadPostResponse = action.payload;
        })
        .addCase(actions.LoadInmateMGUserRequestForumThreadPost.rejected, (state, action) => {
            state.LoadInmateMGUserRequestForumThreadPostResponse = { error: action.error };
        })
        .addCase(actions.LoadRequestForumMGUserThreadRespond.pending, (state) => {
            state.LoadRequestForumMGUserThreadRespondResponse = [];
        })
        .addCase(actions.LoadRequestForumMGUserThreadRespond.fulfilled, (state, action) => {
            state.LoadRequestForumMGUserThreadRespondResponse = action.payload;
        })
        .addCase(actions.LoadRequestForumMGUserThreadRespond.rejected, (state, action) => {
            state.LoadRequestForumMGUserThreadRespondResponse = { error: action.error };
        });
}

